import './overlay.scss';

import AjaxLoad from './../../utilities/js/ajax-load';
import { createElementFromHTML } from '../../utilities/js/helper';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Overlay {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-overlay',
            targetAttr: 'data-overlay-url',
            loader: window.OPTIONS.loader,
            onOpened: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$overlay = $element;

        this.open = false;
        this.$overlayWrapper = document.querySelector(`[${this.settings.initAttr}="wrapper"]`);
        this.content = null;
        this.overlayTarget = this.$overlay.getAttribute(`${this.settings.targetAttr}`);
        this.$overlayClose = null;

        this.$loader = createElementFromHTML(this.settings.loader);

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    closeOverlay () {
        this.$overlayWrapper.classList.remove('is--visible');
        this.open = false;

        enableBodyScroll(this.$overlayContent);

        setTimeout(() => {
            this.$overlayWrapper.remove();
            this.$overlayWrapper = null;
        }, 500);
    }

    getContent () {
        if (this.overlayTarget) {
            const url = this.overlayTarget;

            if (url) {
                new AjaxLoad(encodeURI(url), { // eslint-disable-line
                    requestMethod: 'GET',
                    onSuccess: (data) => {
                        this.content = createElementFromHTML(data);
                        this.generateOverlay();
                    },
                    onError: () => {
                        if (typeof callback === 'function') {
                            console.log('Something went wrong');
                        }
                    }
                });
            } else {
                if (typeof callback === 'function') {
                    console.log('name', 'callback');
                }
            }
        }
    }

    initOverlayContent () {
        window.overlayInitialized = true;
        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$overlayWrapper
            }
        });

        window.setTimeout(() => {
            window.dispatchEvent(contentUpdateEvent);
        }, 500);

        const overlayLoadedEvent = new CustomEvent('overlay.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$overlayContent,
                $store: document.querySelector('[data-store-finder="results"]')
            }
        });

        window.setTimeout(() => {
            window.dispatchEvent(overlayLoadedEvent);
        }, 500);
    }

    generateOverlay () {
        let template;

        if (!this.$overlayWrapper && this.content !== null) {
            this.$overlayWrapper = document.createElement('section');
            this.$overlayWrapper.setAttribute('data-overlay', 'wrapper');
            this.$overlayWrapper.classList.add('overlay');
            template = '<div class="overlay__inner"><div data-overlay="content" class="overlay__content"><div data-overlay="close" class="overlay__close icon-close"></div></div></div>';
            this.$overlayWrapper.innerHTML = template;
            document.body.appendChild(this.$overlayWrapper);
            this.$overlayContent = this.$overlayWrapper.querySelector(`[${this.settings.initAttr}="content"]`);
            this.$overlayContent.appendChild(this.content);

            this.$overlayClose = this.$overlayWrapper.querySelector(`[${this.settings.initAttr}="close"]`);

            this.open = true;
            this.initOverlayContent();

            this.$loader.parentNode.removeChild(this.$loader);
            this.$overlay.classList.remove('is--disabled');

            setTimeout(() => {
                this.$overlayWrapper.classList.add('is--visible');

                disableBodyScroll(this.$overlayContent);

                if (typeof this.settings.onOpened === 'function') {
                    this.settings.onOpened(this.$overlayContent);
                }
            }, 500);
        }
    }

    setEvents () {
        if (this.$overlay) {
            this.$overlay.addEventListener('click', (e) => {
                this.$overlay.appendChild(this.$loader);
                this.$overlay.classList.add('is--disabled');
                this.getContent();

                e.preventDefault();
            });

            document.addEventListener('click', (e) => {
                if (this.open) {
                    if ((!this.$overlayWrapper.contains(e.target) && e.target !== this.$overlayWrapper && e.target !== this.$overlay) || e.target === this.$overlayClose) {
                        this.closeOverlay();
                        e.preventDefault();
                    }
                }
            });
        }
    }
}

export { Overlay };

console.log('load overlay');

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    console.log('content loaded overlay');

    if ($context) {
        const $$overlay = $context.querySelectorAll('[data-overlay="root"]');
        for (let i = 0; i < $$overlay.length; i++) {
            const $overlay = $$overlay[i];

            const OverlayAPI = new Overlay($overlay);
            $overlay.API = OverlayAPI;
        }
    }
});
